import { render, staticRenderFns } from "./PrettyDate.vue?vue&type=template&id=e6630ae0&"
import script from "./PrettyDate.vue?vue&type=script&lang=js&"
export * from "./PrettyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports